// Navbar.js
import React from 'react';
import './Styles.css';

function Navbar({ navbarOpen, setNavbarOpen }) {

    return (
        <nav className="navbar">
            <div className="navbar-logo-container">
                <img src="/static/Villa_Mia_Logo_large-removebg-preview-168w.webp" alt="Villa Mia Logo" className="navbar-logo" />
            </div>
            <ul className={`navbar-menu${navbarOpen ? ' open' : ''}`}>
                <li><a href="https://www.villamiabali.com/" className="navbar-link">Home</a></li>
                <li><a href="https://www.villamiabali.com/villas" className="navbar-link">Villas</a></li>
                <li><a href="https://www.villamiabali.com/activities" className="navbar-link">Location & Activities</a></li>
                <li><a href="https://www.villamiabali.com/contact799c9fc4" className="navbar-link">Contact</a></li>
                <li><a href="https://www.villamiabali.com/faqs" className="navbar-link">FAQs</a></li>
            </ul>
            <button
                className="navbar-hamburger"
                onClick={() => setNavbarOpen(!navbarOpen)}
                aria-label="Open menu"
            >
                <span />
                <span />
                <span />
            </button>
            <div className="navbar-spacer"></div>
        </nav>
    );
}

export default Navbar;
